import { SET_ALL_DATA_OF_CONTACT_STATE } from './AllDataOfContactTypes';
import { SET_SEARCHED_DATA_OF_CONTACT_STATE } from './AllDataOfContactTypes';

const initialState = {
    allDataOfContact: {},
    searchedDataOfContact: {}
}

// Redux reducer start

const allDataOfContactReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_ALL_DATA_OF_CONTACT_STATE: return {
            ...state, 
            allDataOfContact: action.payload,
            searchedDataOfContact: {}
        }
        case SET_SEARCHED_DATA_OF_CONTACT_STATE: return {
            ...state, 
            searchedDataOfContact: action.payload
        }
        default: return state
    }
}

// Redux reducer end

export default allDataOfContactReducer;